import React, { Component } from 'react'
// import adBlock from 'src/img/ad-block.png'
import Ad from '../Ad'
import PropTypes from 'prop-types'
import styles from './AboutPage.module.scss'

class AboutPage extends Component {
  render() {
    const {
      node: { frontmatter, html },
    } = this.props.data

    return (
      <div className={styles.root}>
        <h1 className={styles.title}>{frontmatter.title}</h1>
        <img
          className={styles.promoPicture}
          src={'https://ucarecdn.com/dbc11b6f-5402-451a-b01c-aaa8d4b77623/-/progressive/yes/-/quality/lightest/'}
          alt=""
        />
        <div className={styles.inner}>
          <div className={styles.content} dangerouslySetInnerHTML={{ __html: html }} />
          <div className={styles.ad}>
            <Ad locale={this.props.locale} />
          </div>
        </div>
      </div>
    )
  }
}

AboutPage.propTypes = {
  frontmatter: PropTypes.shape({
    title: PropTypes.string,
  }),
  html: PropTypes.string,
}

export default AboutPage
